import { render, staticRenderFns } from "./flats-crm-items-compare.vue?vue&type=template&id=f46883d4"
import script from "./flats-crm-items-compare.vue?vue&type=script&lang=js"
export * from "./flats-crm-items-compare.vue?vue&type=script&lang=js"
import style0 from "./flats-crm-items-compare.vue?vue&type=style&index=0&id=f46883d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports